export const data = [
    {
        question: 'Как подключить умные камеры от Дом.ru?',
        answers: [
            {
                title: '1) Оставьте заявку на сайте dom.ru, либо через контакт центр. Наш координатор перезвонит вам, ' +
                    'чтобы спланировать время доставки и установки камеры.',
            },
            {
                title: '2) Подключите камеру через WI-FI или напрямую к роутеру с помощью кабеля.',
            },
            {
                title: '3) Скачайте на смартфон приложение «Умный Дом.ru». Синхронизируйте с ним камеру и пользуйтесь услугой в любое удобное время.',
            },
        ]
    },
    {
        question: 'Чем отличается умная камера Дом.ru от обычной камеры видеонаблюдения?',
        answers: [
            {
                text: 'Детектор движения — это датчик внутри камеры, который обнаруживает движения объектов в поле зрения камеры. ' +
                    'Как только камера фиксирует движение в кадре, включается видеозапись и она длится до прекращения движения. ' +
                    'Эта технология позволяет не просматривать многочасовую запись, а получить видео только тех моментов, ' +
                    'когда в поле зрения камеры что-то происходило.'
            }
        ]
    },
    {
        question: 'Есть ли гарантия на оборудование?',
        answers: [
            {
                text: 'Гарантия — 1 год с момента подписания гарантийного талона. Условия не отличаются от любой другой бытовой техники общего пользования.'
            }
        ]
    },
    {
        question: 'Можно ли установить камеры на улице?',
        answers: [
            {
                text: 'Да, в нашем ассортименте есть как домашние камеры, так и уличные, которые работают при температуре от −40 до +50 ℃ и обладают антивандальным корпусом.'
            }
        ]
    },
    {
        question: 'Смогу ли я просматривать видео с камер, находясь в другом городе или за границей?',
        answers: [
            {
                text: 'Да, вы можете смотреть видео с камер из любой точки мира. Для этого нужно подключение к сети интернет и авторизация в приложении «Умный Дом».'
            }
        ]
    },
    {
        question: 'Можно ли добавить к просмотру видео в приложении «Умный Дом.ru» своих членов семьи?',
        answers: [
            {
                text: 'Да, в приложении можно настроить семейный доступ к камере и добавить к просмотру членов семьи.'
            }
        ]
    },
    {
        question: 'Есть ли в камерах микрофон?',
        answers: [
            {
                text: 'Да, в нашем модельном ряду ip-видеокамер есть устройства, оснащенные микрофоном.'
            }
        ]
    }
];
